import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { nextTick } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import staticRoutes from '/@/router/static'
// import { adminBaseRoutePath } from '/@/router/static/adminBase'
import { useSiteConfig } from '@/store/siteConfig'
import { loading } from '/@/utils/loading'
import { useUserInfo } from '@/store/userInfo'

/** 与 layouts/host1/layout.vue 根节点 class 一致：异步路由切换时不要依赖单个 Layout 的 onUnmounted 去掉隐藏滚动条，否则会出现短暂/持续出现 html 滚动条 */
function syncHost1DocumentScrollbarClass() {
	if (document.querySelector('.host1-layout')) {
		document.documentElement.classList.add('host1-hide-scrollbar')
	} else {
		document.documentElement.classList.remove('host1-hide-scrollbar')
	}
}

const router = createRouter({
	// History 模式：地址栏为 /path，无 #（若曾用 createWebHashHistory 才会出现 #）
	history: createWebHistory(import.meta.env.BASE_URL),
	routes: staticRoutes,
	scrollBehavior(_to, _from, savedPosition) {
		if (savedPosition) return savedPosition
		return { top: 0 }
	},
})

router.beforeEach((to, _from, next) => {
	// console.log('beforeEach', to, _from)
	NProgress.configure({ showSpinner: false })
	NProgress.start()
	if (!window.existLoading) {
		loading.show()
		window.existLoading = true
	}

	// 调试信息
	// console.log(`🔄 路由跳转: ${_from.path || '初始'} -> ${to.path}`)
	if (to.matched.length === 0) {
		// console.warn(`⚠️  未匹配到路由: ${to.path}`)
	}

	// 按需动态加载页面的语言包，组件里面与语言到时候还要另外写到/lang/common 里面，没多少文件就全加载了
	/* let loadPath: string[] = []
	const config = useConfig()
	if (to.path in langAutoLoadMap) {
		// console.log('langAutoLoadMap[to.path as keyof typeof langAutoLoadMap]', langAutoLoadMap[to.path as keyof typeof langAutoLoadMap])
		loadPath.push(...langAutoLoadMap[to.path as keyof typeof langAutoLoadMap])
	}
	let prefix = ''
	// if (isAdminApp(to.fullPath)) {
	// 	prefix = './backend/' + config.lang.defaultLang

	// 	// 去除 path 中的 /admin
	// 	// const adminPath = to.path.slice(to.path.indexOf(adminBaseRoutePath) + adminBaseRoutePath.length)
	// 	// if (adminPath) loadPath.push(prefix + adminPath + '.ts')
	// } else {
	// 	prefix = './' + config.lang.defaultLang
	// 	loadPath.push(prefix + to.path + '.ts')
	// }
	prefix = './' + config.lang.defaultLang
	loadPath.push(prefix + to.path + '.ts')
	// 根据路由 name 加载的语言包
	if (to.name) {
		loadPath.push(prefix + '/' + to.name.toString() + '.ts')
	}
	if (!window.loadLangHandle.publicMessageLoaded) window.loadLangHandle.publicMessageLoaded = []
	const publicMessagePath = prefix + '.ts'
	if (!window.loadLangHandle.publicMessageLoaded.includes(publicMessagePath)) {
		loadPath.push(publicMessagePath)
		window.loadLangHandle.publicMessageLoaded.push(publicMessagePath)
	}

	// console.log('loadPath', loadPath)
	// 去重
	loadPath = uniq(loadPath)
	for (const key in loadPath) {
		loadPath[key] = loadPath[key].replaceAll('${lang}', config.lang.defaultLang)
		if (loadPath[key] in window.loadLangHandle) {
			window.loadLangHandle[loadPath[key]]().then((res: { default: anyObj }) => {
				const pathName = loadPath[key].slice(loadPath[key].lastIndexOf(prefix) + (prefix.length + 1), loadPath[key].lastIndexOf('.'))
				mergeMessage(res.default, pathName)
			})
		}
	} */
	// 刷新，且没有初始化
	if (_from?.name == undefined && useSiteConfig().initialize === false) {
		// 动态导入避免循环依赖
		import('../api/Index').then((m) =>
			m.initialize().then(() => {
				next(to.redirectedFrom?.fullPath || to.fullPath || '/')
			})
		)
	} else {
		// 如果有token且去登录页面，那就去控制台
		if (to.name == 'userLogin' && useUserInfo().isLogin()) {
			next({ name: 'user' })
		} else {
			next()
		}
	}
})

// 路由加载后
router.afterEach((to) => {
	if (window.existLoading) {
		loading.hide()
	}
	NProgress.done()
	nextTick(() => {
		requestAnimationFrame(syncHost1DocumentScrollbarClass)
	})
	// console.log(`✅ 路由加载完成: ${to.path}`)
})

// 路由错误处理
router.onError((error) => {
	// console.error('🔴 路由错误：')
	// console.error('错误信息：', error.message)
	// console.error('错误堆栈：\n', error.stack)

	// 检查是否是组件加载错误
	if (error.message.includes('Failed to fetch dynamically imported module')) {
		// console.error('🔍 组件动态加载失败')
		// console.error('可能的原因：')
		// console.error('  1. 组件文件路径错误')
		// console.error('  2. 组件文件不存在')
		// console.error('  3. 组件内部有语法错误')
		// console.error('  4. 组件的导入路径（import）有错误')

		// 尝试从错误信息中提取文件路径
		const urlMatch = error.message.match(/http:\/\/[^\s]+/)
		if (urlMatch) {
			console.error('失败的模块 URL：', urlMatch[0])
		}
	}

	if (window.existLoading) {
		loading.hide()
	}
	NProgress.done()
})

export default router
